import { FC, ReactNode } from 'react';
import { Modal, Typography } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'store/modal';
import { Stack } from '@mui/material';
import Lottie from 'react-lottie-player';
import successAnimation from './assets/success-animation.json';

const SIZE = 112;

interface Props extends ModalProps {
  message: string;
  description?: ReactNode;
}

export const SuccessModal: FC<Props> = ({
  message,
  description,
  closeModal,
}) => {
  const { t } = useTranslation();

  return (
    <Modal.Content
      actions={[
        {
          onClick: () => closeModal(),
          label: t('buttons.ok'),
          autoFocus: true,
        },
      ]}
    >
      <Stack alignItems="center" gap={1}>
        <Lottie
          animationData={successAnimation}
          loop={false}
          play
          style={{ width: SIZE, height: SIZE }}
        />

        <Typography textAlign="center" variant="h2">
          {message}
        </Typography>

        {description ? (
          <Typography textAlign="center" variant="p1" color="textSecondary">
            {description}
          </Typography>
        ) : null}
      </Stack>
    </Modal.Content>
  );
};
